var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconRestaurant = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M6 3.75C6.41421 3.75 6.75 4.08579 6.75 4.5V8.25C6.75 8.80521 7.05165 9.28997 7.5 9.54933V4.5C7.5 4.08579 7.83579 3.75 8.25 3.75C8.66421 3.75 9 4.08579 9 4.5V9.54933C9.44835 9.28997 9.75 8.80521 9.75 8.25V4.5C9.75 4.08579 10.0858 3.75 10.5 3.75C10.9142 3.75 11.25 4.08579 11.25 4.5V8.25C11.25 9.64788 10.2939 10.8225 9 11.1555V19.5C9 19.9142 8.66421 20.25 8.25 20.25C7.83579 20.25 7.5 19.9142 7.5 19.5V11.1555C6.20608 10.8225 5.25 9.64788 5.25 8.25V4.5C5.25 4.08579 5.58579 3.75 6 3.75Z", fill: "#192325" }),
            React.createElement("path", { d: "M14.25 13.5H16.5V19.5C16.5 19.9142 16.8358 20.25 17.25 20.25C17.6642 20.25 18 19.9142 18 19.5V4.5C18 4.08579 17.6642 3.75 17.25 3.75C15.1789 3.75 13.5 5.42893 13.5 7.5V12.75C13.5 13.1642 13.8358 13.5 14.25 13.5ZM15 7.5C15 6.52034 15.6261 5.68691 16.5 5.37803V12H15V7.5Z", fill: "#192325" }))),
        alt: 'Restaurant',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconRestaurant;
//# sourceMappingURL=index.js.map